import * as filestack from 'filestack-js'
const filestackUploader = ({
  file,
  prefixedName,
  onProgress = function () {},
  onError = function () {},
  onSuccess = function () {},
}) => {
  const apikey = process.env.FILESTACK_API_KEY
  const client = filestack.init(apikey)
  client.on('upload.error', filestackError => {
    console.log(filestackError)
    onError(filestackError.toString())
  })

  const handleProgress = evt => {
    console.log('filestack onprogress: ')
    console.log(evt)
    onProgress(evt.totalPercent)
  }

  const token = {}

  client
    .upload(
      file,
      { onProgress: handleProgress },
      { filename: prefixedName },
      token,
    )
    .then(res => {
      console.log('filestack onsuccess: ', res)
      if (res.key) {
        //res.key becomes s3 filename
        onSuccess(res.key)
      } else {
        onError(res)
      }
    })
    .catch(err => {
      console.log(err)
      onError(err)
    })

  return client
}
export default filestackUploader
